module.exports = __webpack_public_path__ + "img/podcast.727e2570.svg";